const rootUrl =
  process.env.NODE_ENV === "production" ? "https://phonein.mynew.jobs/api" : "";

export default rootUrl;
